import _ from 'lodash';

interface LoDashMixins extends _.LoDashStatic {
  isDefined(value: any): boolean;
  uncapitalize(value: string): string;
  objectDiff(newData: any, oldData: any): boolean;
  objectKeysFromArray<T>(arr: T, initValue?: string): T;
  findKeysDeep(obj: any, key: string): [];
}
_.mixin({
  isDefined: (value) => !_.isUndefined(value),
  uncapitalize: (value) => `${value.charAt(0).toLowerCase()}${value.slice(1)}`,
  pushIfDefined: (array, value) => {
    if (_.isUndefined(value)) {
      return array;
    }
    if (!_.isArray(value)) {
      value = [value];
    }
    _.forEach(value, (i) => {
      array.push(i);
    });
    return array;
  },
});

// Method to compare two objects / arrays / primitive types
_.mixin({
  objectDiff: (newData, oldData) => {
    // If array, sort them before comparison
    if (_.isArray(newData)) {
      newData.sort();
      oldData.sort();
    }
    // Returns true if there is a difference
    return !_.isEqual(newData, oldData);
  },
});

_.mixin({
  objectKeysFromArray: (arr, initValue = '') =>
    _.reduce(
      arr,
      (obj: any, key: string | number) => {
        obj[key] = initValue;
        return obj;
      },
      {}
    ),
});

// Find all the values of a certain key insinde an object
const findKeysDeep = (obj: any, searchKey: string | number) =>
  _.reduce(
    obj,
    (result: typeof value[], value, key) => {
      if (!result) result = [];
      if (key === searchKey) {
        result.push(value);
      } else if (_.isObject(value)) {
        const rslt = findKeysDeep(value, searchKey);
        if (rslt) result.push(...rslt);
      }
      return result;
    },
    []
  );

_.mixin({
  findKeysDeep,
});

export default <LoDashMixins>_;
